import { useSelector } from 'react-redux';

const UseCurrency = () => {
  const searchFlightsResult = useSelector(store => store.searchFlightsResult);

  const is_in_usd =
    (searchFlightsResult?.object_clusters &&
      searchFlightsResult.object_clusters[
        searchFlightsResult.clusters[0].cluster_id
      ].is_dollar) ||
    false;

  const ars = num =>
    num
      ? `$ ${num < 0 ? '-' : ''}${Math.abs(num).toLocaleString('es-ar', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : 0;

  const usd = num =>
    num
      ? `USD ${num < 0 ? '-' : ''}${Math.abs(num).toLocaleString('es-ar', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : 0;

  const currency = num => (is_in_usd ? usd(num) : ars(num));

  return {
    currency,
  };
};

export default UseCurrency;
